"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostalMailStatus = void 0;
var PostalMailStatus;
(function (PostalMailStatus) {
    PostalMailStatus["UNASSIGNED"] = "Unassigned";
    PostalMailStatus["UNREAD"] = "Unread";
    PostalMailStatus["READ"] = "Read";
    PostalMailStatus["ARCHIVED"] = "Archived";
    PostalMailStatus["DELETED"] = "Deleted";
})(PostalMailStatus = exports.PostalMailStatus || (exports.PostalMailStatus = {}));
